// メール送信関連の共通設定

// 送信・予約画面のBCC欄に初期表示するアドレス（画面上で削除・変更可能）
export const DEFAULT_BCC_EMAIL = 'lms_assessment@re-current.co.jp';
